type UnifiedSignupStartScreenName =
  | 'generic-signup'
  | 'trial-plan'
  | 'free-plan'
  | 'edu-plan'
  | 'landing-page'
  | 'buy-standard'
  | 'buy-pro'
  | 'homepage-signup';

export default class UnifiedSignupStartScreen {
  public readonly startScreen: UnifiedSignupStartScreenName;

  public static readonly genericSignup = new UnifiedSignupStartScreen({ val: 'generic-signup' });

  public static readonly trialPlan = new UnifiedSignupStartScreen({ val: 'trial-plan' });

  public static readonly freePlan = new UnifiedSignupStartScreen({ val: 'free-plan' });

  public static readonly eduPlan = new UnifiedSignupStartScreen({ val: 'edu-plan' });

  public static readonly landingPage = new UnifiedSignupStartScreen({ val: 'landing-page' });

  public static readonly buyStandard = new UnifiedSignupStartScreen({ val: 'buy-standard' });

  public static readonly buyPro = new UnifiedSignupStartScreen({ val: 'buy-pro' });

  public static readonly homepageSignup = new UnifiedSignupStartScreen({ val: 'homepage-signup' });

  private static mappings: Record<string, UnifiedSignupStartScreen> = {
    'generic-signup': UnifiedSignupStartScreen.genericSignup,
    'trial-plan': UnifiedSignupStartScreen.trialPlan,
    'free-plan': UnifiedSignupStartScreen.freePlan,
    'edu-plan': UnifiedSignupStartScreen.eduPlan,
    'landing-page': UnifiedSignupStartScreen.landingPage,
    'buy-pro': UnifiedSignupStartScreen.buyPro,
    'buy-standard': UnifiedSignupStartScreen.buyStandard,
    'homepage-signup': UnifiedSignupStartScreen.homepageSignup,
  };

  private constructor({ val }: { val: UnifiedSignupStartScreenName }) {
    this.startScreen = val;
  }

  public compareTo(rhs: UnifiedSignupStartScreen) {
    return this.startScreen === rhs.startScreen;
  }

  public static fromString(val: string): UnifiedSignupStartScreen {
    const screen = UnifiedSignupStartScreen.mappings[`${val}`];
    if (!screen) throw new Error(`Could not find start screen with val: '${val}'`);
    return screen;
  }
}
